import FuseAnimate from '@/@fuse/core/FuseAnimate';
import { useForm } from '@/@fuse/hooks';
import * as authActions from '@/app/auth/store/actions';
import { CircularProgress } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import clsx from 'clsx';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import './Loginpagecss.css';
import GradientButton from '@shared/components/GradientButton';

const useStyles = makeStyles((theme) => ({
	root: {
		background: 'url(assets/images/banner/bg.png) no-repeat center',
		backgroundSize: 'cover',
		color: theme.palette.primary.contrastText,
	},
}));

const LoginPage = () => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const [hide, setHide] = useState(true);
	const [isLoggingIn, setIsLoggingIn] = useState(false);
	const [emailTxt, setEmailTxt] = useState('');
	const [pswdTxt, setPswdTxt] = useState('');
	const [loginError, setLoginError] = useState('');

	const { form, setForm } = useForm({
		username: '',
		password: '',
	});

	const handleChange = (e) => {
		if (loginError) {
			setLoginError('');
		}

		if (e.target.name === 'username' && !e.target.value.length) {
			setEmailTxt('Email is required');
		} else if (e.target.name === 'password' && !e.target.value.length) {
			setPswdTxt('Password is required');
		}
		if (e.target.name === 'username' && e.target.value.length) {
			setEmailTxt('');
		} else if (e.target.name === 'password' && e.target.value.length) {
			setPswdTxt('');
		}
		setForm({
			...form,
			[e.target.name]: e.target.value,
		});
	};

	function handleSubmit(e) {
		e.preventDefault();
		setLoginError('');

		if (form.username.length === 0) {
			setEmailTxt('Email is required');
		}
		if (form.password.length === 0) {
			setPswdTxt('Password is required');
		}
		if (form.username.length === 0 || form.password.length === 0) {
			return 0;
		}
		setIsLoggingIn(true);
		let username;
		if (Number.isFinite(Number(form.username))) {
			username = `+${form.username}`;
		} else {
			username = form.username;
		}
		const { password } = form;

		dispatch(authActions.submitLogin({ username, password }, setIsLoggingIn)).then((response) => {
			console.log(response);
			if (response?.type === 'LOGIN_ERROR') {
				if (response.payload?.response?.data?.message) {
					setLoginError(response.payload.response.data.message);
				} else {
					setLoginError('Invalid email or password');
				}
			}
		});
		return 1;
	}

	return (
		<div className={clsx(classes.root, 'flex flex-col flex-auto shrink-0 items-center justify-center p-32')}>
			<FuseAnimate animation="transition.expandIn">
				<div className="flex flex-col items-center justify-center w-full">
					<Card className=" h-[500px] rounded-[8px] w-[80vw] sm:w-[401px] shadow-lg">
						<CardContent className="flex flex-col items-center justify-center p-32">
							<img alt="logo" className="mb-2 gd text-center logo-img" src="assets/images/logos/logo.png" width={150} />
							<Typography className="mt-11 mb-32 hellloooo" variant="h6">
								Welcome to perfect day
							</Typography>

							<form className="flex flex-col justify-center w-full" name="loginForm" noValidate onSubmit={handleSubmit}>
								<div className="insert">
									<TextField
										// eslint-disable-next-line jsx-a11y/no-autofocus
										autoFocus
										className="mb-16"
										error={!!emailTxt.length}
										fullWidth
										helperText={emailTxt}
										id="email"
										label="Email or Phone number"
										name="username"
										onChange={handleChange}
										required
										type="email"
										value={form.username}
									/>
								</div>
								<div className="insert">
									<TextField
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													<IconButton onClick={() => setHide(!hide)}>
														{hide ? <VisibilityOffIcon /> : <VisibilityIcon />}
													</IconButton>
												</InputAdornment>
											),
										}}
										className="mb-4 "
										error={!!pswdTxt.length}
										fullWidth
										helperText={pswdTxt}
										id="password"
										label="Password"
										name="password"
										onChange={handleChange}
										required
										type={hide ? 'password' : 'text'}
										value={form.password}
									/>
								</div>
								<div className="text-[13px] text-right text-[#009dff] font-bold hover:underline">
									<Link to="/forgot-password">Forgot Password</Link>
								</div>
								{isLoggingIn ? (
									<div style={{ paddingLeft: '45%', paddingTop: '4%' }}>
										<CircularProgress size={35} />
									</div>
								) : (
									<div className="flex justify-center mt-32">
										<GradientButton variant="tertiary" size="small" type="submit" width={145}>
											Login
										</GradientButton>
									</div>
								)}
								{loginError ? (
									<Typography color="error" className="mt-16 text-center">
										{loginError}
									</Typography>
								) : null}
							</form>
						</CardContent>
					</Card>
				</div>
			</FuseAnimate>
		</div>
	);
};

export default LoginPage;
